import React from 'react';
import { InputGroup } from 'reactstrap';
import 'css/input-box.css';

export default function DreamSearchForm({
  value,
  onChange,
  onSubmit,
  isLoading,
  variant = 'home',
}) {
  const isCompact = variant === 'compact';

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <section
      id="search"
      aria-label="ค้นหาเลขเด็ดจากความฝัน"
      className={`dream-search${isCompact ? ' dream-search--compact' : ''}`}
    >
      <div id="search-anchor" className="search-anchor" aria-hidden="true" />

      {!isCompact && (
        <div className="hero-card">
          <h1 className="page-heading">พิมพ์ฝันหาเลขเด็ด</h1>
          <p className="page-subheading">
            หาเลขนำโชคจากความฝัน เช็คสถิติย้อนหลัง 32 ปี ฟรี
          </p>
          <div className="feature-pills" aria-label="ฟีเจอร์หลัก">
            <span className="feature-pill">🌙 ทำนายฝัน</span>
            <span className="feature-pill">📊 สถิติหวย</span>
            <span className="feature-pill">✨ เลขเด็ดงวดนี้</span>
          </div>
        </div>
      )}

      <div className="search-card">
        <form
          className="search-form"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <div className="input-icon-addon">
            <span className="search-input-icon" aria-hidden="true">🔍</span>
            <InputGroup>
              <input
                id="input-box"
                type="search"
                placeholder="ฝันว่า ??? เช่น งูใหญ่, ฝันเห็นพระ"
                autoFocus={!isCompact}
                autoComplete="off"
                enterKeyHint="search"
                aria-label="ค้นหาความฝันหรือเลขเด็ด"
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDown}
              />
            </InputGroup>
          </div>
          <button
            type="submit"
            className="search-submit-btn"
            disabled={isLoading || !value?.trim()}
            aria-busy={isLoading}
          >
            {isLoading ? (
              <span className="search-submit-btn__loading">กำลังค้นหา...</span>
            ) : (
              'ค้นหาเลขเด็ด'
            )}
          </button>
        </form>
      </div>
    </section>
  );
}
